import { HEADER_HEIGHT } from 'constants/layout'
import React from 'react'
import styled, { css } from 'styled-components'

const Teaser = styled.div<Partial<IProps>>`
  height: calc(100vh - ${HEADER_HEIGHT}px);
  min-height: 500px;
  position: relative;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;

  ${({ color }) =>
    css`
      background-color: ${color};
    `};
`

interface IProps {
  color: string
  className?: string
}

const FullscreenColorTeaser: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { color, children, className } = props
  return (
    <Teaser color={color} className={className}>
      {children}
    </Teaser>
  )
}

export default FullscreenColorTeaser
